import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { accountTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const setAccountRoles: accountTypes.SetAccountRoles = ({ id, roleIds }) => {
  return axios.patch(`/accounts/${id}/roles`, { roleIds });
};

type UseSetAccountRolesOptions = {
  config?: MutationConfig<typeof setAccountRoles>;
};

export function useSetAccountRoles({ config = {} }: UseSetAccountRolesOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      toasts.loadingToast.loading('set-account-roles', 'Updating roles...');
      config.onMutate?.(...args);
    },
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['accounts']);
      queryClient.invalidateQueries(['account-me']);
      toasts.loadingToast.success('set-account-roles', 'Roles updated successfully');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('set-account-roles', serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: setAccountRoles,
  });
}
